import { StyleSheet } from 'react-native';

import ActionButton from 'components/action-button';
import { Box, Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';
import { LayoutWidth } from 'styles/constants/enums';

import { useStartOrderFromAccountDrawer } from './use-start-order-from-account-drawer';

export const StartOrderEmptyState = () => {
  const startOrder = useStartOrderFromAccountDrawer();

  return (
    <Box style={styles.emptyState}>
      <Typography
        accessibilityLevel={1}
        fontFamily="heading"
        fontSize="3xl"
        lineHeight="2xs"
        style={styles.header}
        variant="headerOne"
      >
        {t('noOrdersItemsYet')}
      </Typography>
      <Typography style={styles.subheader} variant="copyOne">
        {t('recentOrdersEmptySubHeader')}
      </Typography>
      <ActionButton onPress={startOrder}>{t('startOrder')}</ActionButton>
    </Box>
  );
};

const styles = StyleSheet.create({
  emptyState: {
    alignItems: 'center',
    flexDirection: 'column',
    maxWidth: LayoutWidth.SMALL,
    width: '83.333%',
  },
  header: {
    color: primitive.$greyOne,
    marginBottom: 0,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  subheader: {
    marginBottom: 32,
    marginHorizontal: 0,
    marginTop: 16,
    textAlign: 'center',
  },
});
